import React from 'react';
import { Button } from './ui/Button';
const BEEHIIV_URL = 'https://theproductivityblueprint.beehiiv.com';
interface SubscribeFormProps {
  variant?: 'hero' | 'inline' | 'footer';
  className?: string;
}
export function SubscribeForm({
  variant = 'inline',
  className = ''
}: SubscribeFormProps) {
  const isHero = variant === 'hero';
  const isFooter = variant === 'footer';
  return <div className={`${className}`} data-id="element-203">
      <Button variant={isFooter ? 'secondary' : 'primary'} size={isHero ? 'lg' : 'md'} className={isHero ? 'min-w-[160px]' : ''} onClick={() => window.open(BEEHIIV_URL, '_blank', 'noopener,noreferrer')} data-id="element-204">
        Subscribe
      </Button>
      {isHero && <p className="mt-3 text-sm text-brand-slate/70" data-id="element-205">
          Free, every Sunday. Unsubscribe anytime.
        </p>}
    </div>;
}